/* v3 reveal-on-scroll: elements with .v3-reveal fade/rise in, staggered. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );
  document.querySelectorAll('.v3-reveal').forEach(function (el, i) {
    el.style.transitionDelay = Math.min(i, 4) * 60 + 'ms';
    io.observe(el);
  });
})();
